"use strict";

exports.__esModule = true;
exports.AccommodationCartClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const AccommodationCartClient = {
  /**
   * get cart info
   * @param {string} cartId
   * @param {string} searchParams
   * @return {Promise}
   */
  getCart({
    cartId
  }) {
    const requestId = 'GET_ACCOMMODATION_CART';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ACCOMMODATION.GET_CART, {
      cartId
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * checkout
   * @description checkout flight cart
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {Array<Object>} payload.traveller
   * @param {string} payload.payment
   * @param {number} payload.total
   * @param {string} payload.specialRequest
   * @param {string} payload.captcha_token
   * @returns {Promise<Cart>}
   */
  checkout(payload) {
    const requestId = 'CHECKOUT_ACCOMMODATION_CART';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ACCOMMODATION.CHECKOUT, {
      cartId: payload.cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * redeem Qitaf
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {number} payload.total
   * @param {Object} payload.loyalty
   * @param {string} payload.loyalty.method redeem method
   * @param {string} payload.loyalty.identifier phone number
   * @param {string} payload.loyalty.code PIN code sent to identifier number
   * @param {string} payload.loyalty.total total amount to be deducted from redeemed points
   * @return {Promise<Cart>}
   */

  redeemQitaf(payload) {
    const requestId = 'QITAF_REDEEM_ACCOMMODATION_CART';
    const endPoint = _constants.ENDPOINTS.ACCOMMODATION.LOYALTY_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * redeem Wallet
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {number} payload.total
   * @param {Object} payload.loyalty
   * @param {string} payload.loyalty.method redeem method
   * @param {string} payload.loyalty.identifier phone number
   * @param {string} payload.loyalty.code PIN code sent to identifier number
   * @param {string} payload.loyalty.total total amount to be deducted from redeemed points
   * @return {Promise<Cart>}
   */
  redeemWallet(payload) {
    const requestId = 'WALLET_REDEEM_ACCOMMODATION_CART';
    const endPoint = _constants.ENDPOINTS.ACCOMMODATION.LOYALTY_REDEEM;
    return _http.$http.post(requestId, endPoint, {
      data: payload
    }).then(({
      data
    }) => data);
  },
  /**
   * apply coupon
   * @param {Object} payload
   * @param {string} payload.cartId
   * @param {string} payload.couponCode
   * @param {Object} payload.payment
   * @param {string} payload.payment.method
   * @param {Object} payload.payment.card
   * @param {string} payload.payment.card.number first 6 digits string of card number
   * @return {Promise<Cart>}
   */
  applyCoupon({
    cartId,
    couponCode,
    ...restPayload
  }) {
    const requestId = 'APPLY_COUPON_ACCOMMODATION';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ACCOMMODATION.APPLY_COUPON, {
      cartId,
      couponCode
    });
    return _http.$http.post(requestId, endPoint, {
      data: restPayload
    }).then(({
      data
    }) => data);
  },
  /**
   * remove coupon
   * @param {Object} payload
   * @param {string} payload.cartId
   * @return {Promise<Cart>}
   */
  removeCoupon({
    cartId
  }) {
    const requestId = 'REMOVE_COUPON_ACCOMMODATION';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ACCOMMODATION.REMOVE_COUPON, {
      cartId
    });
    return _http.$http.delete(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * get order
   * @param {Object} payload
   * @param {string} payload.orderId
   * @return {Promise<Order>}
   */
  getOrder({
    orderId
  }) {
    const requestId = 'GET_ACCOMMODATION_ORDER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.ACCOMMODATION.GET_ORDER, {
      orderId
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  }
};
exports.AccommodationCartClient = AccommodationCartClient;